module.exports = __webpack_public_path__ + "img/6.67c5a885.jpg";